import * as _4 from 'lodash4';
import { ISection } from '../../../interfaces/scheduler_interfaces';

export class MeetingTimeServant {
  hasMultipleMeetingTimes(section: ISection) {
    const sectionTimes = _4.get(section, '_section_times', []);
    const hasMultipleToDate = _4.uniqBy(sectionTimes, 'to_dt').length > 1;
    const hasMultipleFromDate = _4.uniqBy(sectionTimes, 'from_dt').length > 1;
    const hasMultipleLocation = _4.uniqBy(sectionTimes, 'location').length > 1;
    return hasMultipleToDate || hasMultipleFromDate || hasMultipleLocation;
  }

  getMultipleMeetingTimesCount(section: ISection) {
    return _4.get(section, '_section_times', []).length;
  }
  dateDifferenceInWeeksOrDays(startDt: string, endDt: string) {
    const startDate = startDt;
    const endDate = endDt;
    let timeDiffTitle = '';
    const hasValidTimeDiff = !!startDate && !!endDate;

    if (hasValidTimeDiff) {
      const startDateObj = moment.isMoment(startDate) ? startDate : moment(startDate);
      let endDateObj = moment.isMoment(endDate) ? endDate : moment(endDate);
      endDateObj = endDateObj.add(1, 'day');

      const timeDiffInWeeks = endDateObj.diff(startDateObj, 'weeks');
      const timeDiffInDays = endDateObj.diff(startDateObj, 'days');

      const weekString = timeDiffInWeeks > 1 ? 'Weeks' : 'Week';
      const dayString = timeDiffInDays > 1 ? 'Days' : 'Day';

      timeDiffTitle = timeDiffInWeeks ? `${timeDiffInWeeks} ${weekString}` : `${timeDiffInDays} ${dayString}`;
    }
    return timeDiffTitle;
  }
}

angular.module('capability-ng-scheduler').service('ngMeetingTimeServant', MeetingTimeServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/meeting_times/servants/meeting_time_servant.ts